import gql from 'graphql-tag'

export const VALIDATE_MAIL = gql`
  mutation validateMail($input: ValidateMailInput!) {
    validateMail(input: $input) {
      status
    }
  }
`
